import { Card, CardContent } from "./ui/card";

export const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  trendValue,
  variant = "default",
  className = "",
  testId = ""
}) => {
  const variants = {
    default: "bg-white",
    primary: "bg-gradient-to-br from-primary/10 to-primary/5",
    success: "bg-gradient-to-br from-success/10 to-success/5",
    warning: "bg-gradient-to-br from-warning/10 to-warning/5",
    error: "bg-gradient-to-br from-error/10 to-error/5",
  };

  const iconVariants = {
    default: "bg-slate-100 text-slate-600",
    primary: "bg-primary/20 text-primary",
    success: "bg-success/20 text-success",
    warning: "bg-warning/20 text-warning",
    error: "bg-error/20 text-error",
  };

  return (
    <Card 
      className={`${variants[variant]} border-none shadow-sm card-hover ${className}`}
      data-testid={testId}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">{title}</p>
            <p className="text-2xl font-bold text-slate-900">{value}</p>
            {trend && (
              <p className={`text-xs mt-2 ${trend === "up" ? "text-success" : "text-error"}`}>
                {trend === "up" ? "↑" : "↓"} {trendValue}
              </p>
            )}
          </div>
          {Icon && (
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${iconVariants[variant]}`}>
              <Icon className="w-6 h-6" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
